<template>
  <b-form @submit.prevent>
    <b-row v-if="HasPermission(PermissionList.Production_Finance)">
      <b-col md="12">
        <b-form-group label="Sales Price" label-for="Operation-name">
          <b-form-input id="Operation-name" type="number" v-model="data.invoiceAmount" />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Cost of BOM" label-for="Operation-name">
          <b-form-input id="Operation-name" type="number"
            placeholder="Please enter price of BOM" v-model="data.totalCostOfProduction"
             />
        </b-form-group>
      </b-col>
      <!-- <b-col md="12">
        <b-form-group label="Actual Total BOM Cost" label-for="Operation-name">
          <b-form-input id="Operation-name" type="number"
            placeholder="This is fetched from the Job Cards based on the Operations run on the Items."
            v-model="data.actualCost" disabled />
        </b-form-group>
      </b-col> -->
      <b-col md="6">
        <b-form-group label="Labour Cost" label-for="labour-cost">
          <b-form-input id="labour-cost" type="number" v-model="data.labourCost" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Comment" label-for="labour-cost-details">
          <b-form-input id="labour-cost-details" placeholder="Add Detailed Cost" type="text" v-model="data.labourCostDetails" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Transport/Logistics Cost" label-for="transport-cost">
          <b-form-input id="transport-cost" type="number" v-model="data.transportCost" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Comment" label-for="transport-cost-details">
          <b-form-input id="transport-cost-details" placeholder="Add Detailed Cost" type="text" v-model="data.transportCostDetails" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Any Other Additional Operating Cost" label-for="Operation-name">
          <b-form-input id="Operation-name" type="number" v-model="data.additionalCost" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Comment" label-for="Operation-name-details">
          <b-form-input id="Operation-name-details" placeholder="Add Detailed Cost" type="text" v-model="data.additionalCostDetails" />
        </b-form-group>
      </b-col>
      <!-- <b-col md="12">
        <b-form-group label="Total Operating Cost" label-for="Operation-name">
          <b-form-input id="Operation-name" type="number"
            placeholder="This is calculated as Actual Operating Cost + Additional Operating Cost."
            v-model="data.totalOperationCost" disabled />
        </b-form-group>
      </b-col> -->
    </b-row>
  </b-form>
</template>

<script>
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  watch: {
    'data.actualCost': 'calculateTotalOperationCost',
    'data.labourCost': 'calculateTotalOperationCost',
    'data.transportCost': 'calculateTotalOperationCost',
    'data.additionalCost': 'calculateTotalOperationCost',
    
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },

  methods: {
    calculateTotalOperationCost() {
      let sumOfOperationSteps = 0;
      this.data.operationSteps.forEach(step => {
        sumOfOperationSteps += step.totalCost; 
      });
      this.data.totalOperationCost = parseFloat(this.data.actualCost) +
        parseFloat(this.data.labourCost) +
        parseFloat(this.data.transportCost) +
        parseFloat(this.data.additionalCost) +
        sumOfOperationSteps; 
    },
  },
  created() {
    this.calculateTotalOperationCost(); 
  },

};
</script>
